module.exports = "<a nav-clear class=\"tab-item margin-left-40\"\r\n              ng-class=\"{ active: ('settings' | includedByState) || ('teamDetail' | includedByState) || ('teamAdd' | includedByState) || ('user' | includedByState) || ('changeUser' | includedByState) || ('imprint' | includedByState)}\"\r\n              ng-click=\"$ctrl.openPopover($event)\">\r\n    <i class=\"icon ion-ios-person ion-android-person\"></i><span class=\"welcome-label\">{{ $ctrl.firstName }}</span>\r\n</a>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/directives/popovers/userNavigationElement.html
 ** module id = 458
 ** module chunks = 0
 **/